export const QUIZ_MAIN_TAB = 0;

export const QUIZ_TYPE_OPEN = 'text';
export const QUIZ_TYPE_CLOSED = 'multiple_choice';

export const QUIZ_OPEN_ANSWER_TEXT = 'open-answer-not-visible';
